import React from "react";
import T from "prop-types";

import Widget from "2g-widget";
import PageMessage from "2g-page-message";

import useMessages from "./i18n/useMessages";
import useFixniNarokyNasledujiciWidget from "./useFixniNarokyNasledujiciWidget";
import FixniNarokyNasledujiciItem from "./FixniNarokyNasledujiciItem";

export function FixniNarokyNasledujiciWidget({ ico }) {
  const { nasledujiciWidgetTitle, nasledujiciWidgetTitleDescription } =
    useMessages();
  const { data, loading, error } = useFixniNarokyNasledujiciWidget({
    ico
  });
  return (
    <Widget
      title={nasledujiciWidgetTitle()}
      titleDescription={nasledujiciWidgetTitleDescription()}
      titleDescriptionOnlyBottom
      collapsable={false}
    >
      {error ? (
        <PageMessage inline>{error}</PageMessage>
      ) : loading ? (
        <ul>
          <FixniNarokyNasledujiciItem loading />
        </ul>
      ) : (
        <ul className="b2b-FixniNarokyNasledujici-items">
          {data?.map((item, index) => (
            <FixniNarokyNasledujiciItem key={index} {...item} />
          ))}
        </ul>
      )}
    </Widget>
  );
}

FixniNarokyNasledujiciWidget.propTypes = {
  ico: T.number
};

export default React.memo(FixniNarokyNasledujiciWidget);
